import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import { BASE_URL } from '../../config/constants';
import { useTranslation } from 'react-i18next';
function AddPackage() {
	const { t } = useTranslation();
	const [packageData, setPackageData] = useState({
		name: '',
		description: '',
		price: '',
		duration: '',
		status: '',
		isOffer: '',
	});
	const [packages, setPackages] = useState([]);
	const [packageId, setPackageId] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const baseUrl = BASE_URL;
	useEffect(() => {
		fetchPackages();
	}, []);

	const handleInputsValue = (e) => {
		const { name, value } = e.target;
		setPackageData({
			...packageData,
			[name]: name === 'price' || name === 'duration' ? Number(value) : value,
		});
	};

	const handleSubmitForm = async (e) => {
		e.preventDefault();

		try {
			const updatedPackageData = {
				...packageData,
			};

			const packageResponse = await fetch(
				isEditing
					? `${baseUrl}/api/v1/packages/${packageId}`
					: `${baseUrl}/api/v1/packages`,
				{
					method: isEditing ? 'PATCH' : 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
					body: JSON.stringify(updatedPackageData),
				}
			);

			if (packageResponse.ok) {
				alert(
					isEditing
						? 'Package updated successfully'
						: 'Package added successfully'
				);
				setPackageData({
					name: '',
					description: '',
					price: '',
					duration: '',
					status: '',
					isOffer: '',
				});
				setPackageId('');
				setIsEditing(false);
				fetchPackages();
			} else {
				alert('Error saving package data');
			}
		} catch (error) {
			alert('Error uploading form!');
			console.error(error);
		}
	};

	const fetchPackages = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/v1/packages`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setPackages(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleGetPackageData = async (event) => {
		const selectedPackageId = event.target.value;
		setPackageId(selectedPackageId);

		try {
			const response = await fetch(
				`${baseUrl}/api/v1/packages/${selectedPackageId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setPackageData({
					name: data.name,
					description: data.description,
					price: data.price,
					duration: data.duration,
					status: data.status,
					isOffer: data.isOffer,
				});
				setIsEditing(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleDeletePackage = async (event) => {
		event.preventDefault();
		if (!packageId) {
			alert('Please select a package to delete');
			return;
		}

		try {
			const response = await fetch(`${baseUrl}/api/v1/packages/${packageId}`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			if (response.ok) {
				alert('Package deleted successfully');
				setPackageId('');

				setPackageData({
					name: '',
					description: '',
					price: '',
					duration: '',
					status: '',
					isOffer: '',
				});
				fetchPackages();
			} else {
				alert('Error deleting package');
			}
		} catch (error) {
			alert('Error deleting package');
		}
	};

	return (
		<div className='flex justify-center gap-4 items-center flex-wrap container my-6 mt-36'>
			<form
				className='tagForm bg-white p-6 rounded-lg shadow-md w-full  border-2 border-main flex flex-row flex-wrap gap-4 my-4'
				onSubmit={handleSubmitForm}>
				<h2 className='text-2xl text-main font-bold mb-4 w-full'>
					{isEditing ? 'Edit Package' : 'Create Package'}
				</h2>
				<div className='flex flex-col w-full md:w-1/3'>
					<label className='text-main'> {t('name')}</label>
					<input
						type='text'
						name='name'
						value={packageData.name}
						onChange={handleInputsValue}
						placeholder='Name'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col w-full md:w-1/3'>
					<label className='text-main'> {t('description')}</label>
					<input
						type='text'
						name='description'
						value={packageData.description}
						onChange={handleInputsValue}
						placeholder='Description'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow w-full md:w-1/3'>
					<label className='text-main'> {t('price')}</label>
					<input
						type='number'
						name='price'
						value={packageData.price}
						onChange={handleInputsValue}
						placeholder='Price'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow w-full md:w-1/3'>
					<label className='text-main'> {t('duration')}</label>
					<input
						type='number'
						name='duration'
						value={packageData.duration}
						onChange={handleInputsValue}
						placeholder='Duration'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<div className='flex flex-col flex-grow w-full '>
					<label className='text-main'> {t('status')}</label>
					<select
						name='status'
						value={packageData.status}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2 w-full md:w-2/3'>
						<option value=''> {t('selectStatus')}</option>
						<option value='active'>Active </option>
						<option value='inactive'>unActive </option>
					</select>
				</div>
				<div className='flex flex-col flex-grow w-full'>
					<label className='text-main'>Offer </label>
					<select
						name='isOffer'
						value={packageData.isOffer}
						onChange={handleInputsValue}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2 w-full md:w-2/3'>
						<option value=''>Select isOffer </option>
						<option value='true'>true </option>
						<option value='false'>false </option>
					</select>
				</div>
				<button
					type='submit'
					className='w-auto bg-main text-white py-2 px-4 rounded-lg'>
					{isEditing ? 'Update Package' : 'Create Package'}
				</button>
			</form>

			<form className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-wrap gap-3'>
				<h2 className='text-main text-2xl font-bold w-full'>
					{t('editPackage')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={packageId}
					onChange={handleGetPackageData}>
					<option value=''>{t('selectEditPackage')}</option>
					{packages.map((pkg) => (
						<option
							key={pkg.id}
							value={pkg.id}>
							{pkg.name}
						</option>
					))}
				</select>
			</form>

			<form
				className='bg-white p-6 rounded-lg shadow-md w-full  border-2 border-red-600 flex flex-wrap gap-3'
				onSubmit={handleDeletePackage}>
				<h2 className='text-red-600 text-2xl font-bold w-full'>
					{t('deletePackage')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={packageId}
					onChange={handleGetPackageData}>
					<option value=''>{t('selectDeletePackage')}</option>
					{packages.map((pkg) => (
						<option
							key={pkg.id}
							value={pkg.id}>
							{pkg.name}
						</option>
					))}
				</select>
				<button
					type='submit'
					className='w-auto bg-red-600 text-white py-2 px-4 rounded-lg'>
					{t('deletePackage')}
				</button>
			</form>
		</div>
	);
}

export default AddPackage;
